// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  text-align: center;
  font-size: 13px;
  color: #8E9BAA;
}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AACF","sourcesContent":["footer{\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: #8E9BAA;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
